module.exports = __webpack_public_path__ + "static/fruitbowl-fa37b0c2a184ed49b6d496460b5a98d2.png";